import Api from "~/service/Api";

class MediaItemDownloadRepository {
  fetch(tourId, query) {
    return Api.get(`/media-item/downloads/${tourId}`, query);
  }
}

export default MediaItemDownloadRepository;
